import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Params } from '@angular/router';
import { RegexConst } from '@core-constants/regex.const';
import { URLParamConst } from '@core-constants/url-param.const';
import { UTMUserProperties } from '@shared-base/generic-clases.base';
import { CookieService } from 'ngx-cookie-service';

@Injectable({ providedIn: 'root' })
export class UTMOperationHelper
{
  constructor(protected cookieService: CookieService,
    private sanitizer: DomSanitizer) { }

  /**
   * Función que se encarga de la revisión y llamada para el guardado de cookies correspondientes a UTMs
   * @param params
   */
  public buildUTMObject(params: Params): void
  {
    if (params[URLParamConst.UtmSource] && params[URLParamConst.UtmMedium] && params[URLParamConst.UtmCampaign])
    {
      const storedParams = this.cookieService.get(URLParamConst.UtmParams);

      if (storedParams)
      {
        const storedParamsObj = JSON.parse(storedParams);
        if (storedParamsObj.utmSource === params[URLParamConst.UtmSource] && storedParamsObj.utmMedium === params[URLParamConst.UtmCampaign]
          && storedParamsObj.utmCampaign === params[URLParamConst.UtmCampaign])
        {
          return;
        }
      }

      if (this.sanitizeParams(params[URLParamConst.UtmSource])) { return; }
      if (this.sanitizeParams(params[URLParamConst.UtmMedium])) { return; }
      if (this.sanitizeParams(params[URLParamConst.UtmCampaign])) { return; }

      this.saveUTMObject(params);
    }
  }

  public updateUTMData<T extends UTMUserProperties>(dto: T): T
  {
    const data: T = { ...dto };

    const utmParams = this.cookieService.get(URLParamConst.UtmParams);

    if (utmParams)
    {
      const getParamsObj = JSON.parse(utmParams);

      if (getParamsObj.utmSource && getParamsObj.utmMedium && getParamsObj.utmCampaign)
      {
        data.utmSource = getParamsObj.utmSource;
        data.utmMedium = getParamsObj.utmMedium;
        data.utmCampaign = getParamsObj.utmCampaign;
      }
    }

    return data;
  }

  /**
   * Función que almacena el objeto construido en las cookies del navegador y le asigna una fecha de expiración
   */
  public saveUTMObject(params: Params): void
  {
    const expireDate = new Date();

    expireDate.setMonth(expireDate.getMonth() + 6);

    const utmParams = { utmSource: params[URLParamConst.UtmSource], utmMedium: params[URLParamConst.UtmCampaign], utmCampaign: params[URLParamConst.UtmCampaign] };

    this.cookieService.set(URLParamConst.UtmParams, JSON.stringify(utmParams), expireDate);
  }

  public sanitizeParams(utm: string): boolean
  {
    if (RegexConst.SpecialChars.test(utm)) { return true; }
    if (utm !== this.sanitizer.sanitize(SecurityContext.HTML, utm)) { return true; }
    if (utm !== this.sanitizer.sanitize(SecurityContext.STYLE, utm)) { return true; }
    if (utm !== this.sanitizer.sanitize(SecurityContext.URL, utm)) { return true; }
  }

}
